import(/* webpackMode: "eager", webpackExports: ["default"] */ "/working_dir/src/app/ClientLayout.tsx");
;
import(/* webpackMode: "eager" */ "/working_dir/src/app/globals.css");
;
import(/* webpackMode: "eager" */ "/working_dir/public/assets/libs/choices.js/public/assets/styles/choices.min.css");
;
import(/* webpackMode: "eager" */ "/working_dir/public/assets/libs/swiper/swiper-bundle.min.css");
;
import(/* webpackMode: "eager" */ "/working_dir/public/assets/css/tailwind.css");
